import { useEffect, useState } from "react";
import { globalLogout } from "@/services/generic-logout-method";
import SessionExpirePrompt from "@/components/session-expire-prompt";
import { clearAuthCookies } from "@/services/generic.methods";

// 1000 = 1 second
// idle for 2 hours = 7200000 seconds
const IdleTimerWrapper = ({ idleTime = 7200000, children }) => {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    let idleTimer;

    const resetIdleTimer = () => {
      clearTimeout(idleTimer);
      idleTimer = setTimeout(() => {
        onIdle();
      }, idleTime);
    };

    const handleUserActivity = () => {
      resetIdleTimer();
    };

    // Initial setup
    resetIdleTimer();

    // Event listeners
    window.addEventListener("mousemove", handleUserActivity);
    window.addEventListener("keydown", handleUserActivity);

    // Cleanup on unmount or component update
    return () => {
      clearTimeout(idleTimer);
      window.removeEventListener("mousemove", handleUserActivity);
      window.removeEventListener("keydown", handleUserActivity);
    };
  }, [idleTime]);

  const onIdle = () => {
    //show alert if user idle for 2 hours. and then logout
    console.log("user on idle state");
    setOpen(true);
    // logout from back, when user reloads the page it should logout user
    clearAuthCookies();
  };

  const logoutHandler = () => {
    //show alert if user idle for 2 hours. and then logout
    // send to login page
    console.log("user logut");
    let shouldRedirect = true;
    globalLogout(shouldRedirect);
    setOpen(false);
  };

  const handleCloseModal = (e, reason) => {
    console.log("reason", reason);
    if (reason === "backdropClick") {
      return false;
    } else {
      setOpen(false);
    }
  };

  return (
    <>
      {children}
      <SessionExpirePrompt
        open={open}
        message={"Your session has expired, please login again."}
        onClose={handleCloseModal}
        saveCallback={logoutHandler}
      />
    </>
  );
};

export default IdleTimerWrapper;
